import React, {Component, useState} from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Checkbox,
    Tooltip,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Button,
    InputAdornment,
    Divider,
} from '@material-ui/core';
import EventIcon from '@material-ui/icons/Event';
import DateIcon from '@material-ui/icons/CalendarTodayOutlined';
import EditIcon from '@material-ui/icons/BorderColorOutlined';
import {MuiPickersUtilsProvider, DatePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {format, parseISO, isWithinInterval} from 'date-fns';
import zhCNLocale from 'date-fns/locale/zh-CN';
import {ThemeProvider, createTheme} from '@material-ui/core/styles';

import util from 'Utils/commonUtil';
import {PURCHASE_ORDER_MODE} from 'Utils/constant';

// Components
import {Card, Grid} from '@material-ui/core';
import ProductImage from 'Components/commonOrder/ProductImage';

// Actions
import {T} from 'Actions/translate';

const datePickerTheme = createTheme({
    palette: {
        primary: {
            main: '#d32f2f',
        },
    },
});

const OEM_PRODUCT_SOURCE = 'OEM';

class ProductDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            currentProduct: {},
            productList: [...props.productList],
        };
    }

    getSkuDetails = (cartId) => {
        const {skuDetailsList} = this.props;
        let skuDetails;

        skuDetails =
            skuDetailsList &&
            skuDetailsList.filter((item) => {
                return item.cartId === cartId;
            });

        return skuDetails[0] || '';
    };

    savingPrice = (productInfo) => {
        // let savingPrice = parseFloat(this.getSkuDetails(productInfo.cartId).listPrice || 0.00) - parseFloat(this.getSkuDetails(productInfo.cartId).finalPrice || 0.00);
        let savingPrice =
            parseFloat(productInfo.listPrice || 0.0) -
            parseFloat(productInfo.unitPrice || 0.0);
        return util.toMoney(savingPrice);
    };
    isOfflineOemProduct = (productInfo) =>
        util.getPurchaseOrderMode() === PURCHASE_ORDER_MODE.OFFLINE &&
        productInfo.productSource === OEM_PRODUCT_SOURCE;
    onCloseCRD = () => {
        this.setState({open: false});
    };
    onSubmitCRD = (data) => {
        const currentOrderProducts = [];
        const products = this.state.productList.map((item) => {
            currentOrderProducts.push({
                sku: item.sku,
                lineNumber: item.lineNumber,
                crd:
                    data.selectedLinesMap[
                        item.deliveryChannel + item.lineNumber
                    ] || item.crd,
                deliveryChannel: item.deliveryChannel,
            });
            return {
                ...item,
                crd:
                    data.selectedLinesMap[
                        item.deliveryChannel + item.lineNumber
                    ] || item.crd,
            };
        });
        this.setState({productList: products, open: false});
        this.props.setCurrentOrderLines(currentOrderProducts);
    };

    render() {
        const {isTF, holidays} = this.props;
        const {open, currentProduct, productList} = this.state;
        const createMarkup = (text) => ({__html: text});

        return (
            <Card className="product-details-card">
                <Grid
                    className="product-details-title-container no-margin"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid
                        className="product-details-title"
                        item
                        xs={11}
                        testid={
                            isTF
                                ? 'order-confirmation-website-product-indicator'
                                : undefined
                        }>
                        {isTF ? (
                            <span>
                                <img
                                    src={
                                        new URL(
                                            'Images/online.svg',
                                            import.meta.url,
                                        ).href
                                    }
                                    alt=""
                                />{' '}
                                <label>{T('TFS_goods')}</label>
                            </span>
                        ) : (
                            <span>
                                <img
                                    src={
                                        new URL(
                                            'Images/sp-icon.svg',
                                            import.meta.url,
                                        ).href
                                    }
                                    alt=""
                                />{' '}
                                <label>
                                    {T('lto_history_detail_sc_product')}
                                </label>
                            </span>
                        )}
                        {/* <span>{T('productInfo')}</span> */}
                        <span className="red">
                            {!isTF
                                ? T('order_sc_stock_product_delivery')
                                : T('order_global_product_delivery')}
                        </span>
                    </Grid>
                </Grid>

                {productList &&
                    productList.map((productInfo, index) => {
                        return (
                            <>
                                <Grid
                                    key={index}
                                    className="product-details-container"
                                    container
                                    spacing={0}
                                    justify={'space-evenly'}>
                                    <Grid item xs={11}>
                                        <Grid
                                            className="top-content"
                                            container
                                            spacing={0}>
                                            <Grid
                                                className="left-content-grid"
                                                item
                                                xs={3}>
                                                <div className="image-box">
                                                    <ProductImage
                                                        src={
                                                            productInfo.productPic
                                                        }
                                                        alt={
                                                            productInfo.productName
                                                        }
                                                    />
                                                </div>
                                            </Grid>

                                            <Grid
                                                className="right-content-grid"
                                                item
                                                xs={9}>
                                                <Grid
                                                    container
                                                    spacing={0}
                                                    justify={'space-evenly'}>
                                                    <Grid
                                                        className="product-title"
                                                        item
                                                        xs={12}>
                                                        {/*<span>createMarkup(productInfo.productName)</span>*/}
                                                        <div
                                                            dangerouslySetInnerHTML={createMarkup(
                                                                productInfo.productName,
                                                            )}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    className="product-info"
                                                    container
                                                    spacing={0}>
                                                    <Grid item xs={7}>
                                                        {T('product_sku_colon')}
                                                        <span>
                                                            {productInfo.sku}
                                                        </span>
                                                    </Grid>
                                                    {!isTF ? (
                                                        <Grid item xs={5}>
                                                            {T(
                                                                'order_inventory_colon',
                                                            )}
                                                            <span>
                                                                {productInfo.inventory >
                                                                0
                                                                    ? productInfo.inventory
                                                                    : 0}
                                                            </span>
                                                        </Grid>
                                                    ) : null}
                                                </Grid>

                                                <Grid
                                                    className="product-info"
                                                    container
                                                    spacing={0}>
                                                    <Grid item xs={12}>
                                                        {T(
                                                            'product_specifications_colon',
                                                        )}
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: productInfo.specifications,
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                {productInfo.eta && (
                                                    <Grid
                                                        className="product-info"
                                                        container
                                                        spacing={0}>
                                                        <Grid item xs={12}>
                                                            {T('product_eta')}
                                                            <span>
                                                                {
                                                                    productInfo.eta
                                                                }
                                                            </span>
                                                        </Grid>
                                                    </Grid>
                                                )}

                                                {productInfo.displayAttributeList &&
                                                    productInfo
                                                        .displayAttributeList
                                                        .length > 0 && (
                                                        <div className="assayid-content-wrapper">
                                                            {productInfo.displayAttributeList.map(
                                                                (
                                                                    assayIdItem,
                                                                    assayIdIndex,
                                                                ) => (
                                                                    <div
                                                                        className="assayIdArea"
                                                                        key={
                                                                            assayIdIndex
                                                                        }>
                                                                        <label
                                                                            style={{
                                                                                marginRight:
                                                                                    '5px',
                                                                            }}>
                                                                            {
                                                                                assayIdItem.displayName
                                                                            }
                                                                            :
                                                                        </label>
                                                                        <span className="assayIdLabel">
                                                                            {
                                                                                assayIdItem.displayValue
                                                                            }
                                                                        </span>
                                                                    </div>
                                                                ),
                                                            )}
                                                        </div>
                                                    )}
                                                {productInfo.CRD_Range &&
                                                    productInfo.CRD_Range
                                                        .status ===
                                                        'eligible' && (
                                                        <div
                                                            style={{
                                                                padding:
                                                                    '0.3rem 0 0.5rem 1rem',
                                                                fontSize:
                                                                    '0.75rem',
                                                            }}>
                                                            <span>
                                                                <span
                                                                    style={{
                                                                        color: '#b1b1b1',
                                                                    }}>
                                                                    {T(
                                                                        'product_crd_date',
                                                                    )}
                                                                </span>
                                                            </span>
                                                            <span
                                                                onClick={() => {
                                                                    this.setState(
                                                                        {
                                                                            currentProduct:
                                                                                productInfo,
                                                                            open: true,
                                                                        },
                                                                    );
                                                                }}>
                                                                <span
                                                                    style={{
                                                                        marginLeft:
                                                                            '8px',
                                                                        cursor: 'pointer',
                                                                        color: '#2e64ab',
                                                                    }}>
                                                                    {
                                                                        productInfo.crd
                                                                    }
                                                                </span>
                                                                <span
                                                                    style={{
                                                                        marginLeft:
                                                                            '8px',
                                                                        cursor: 'pointer',
                                                                        color: '#2e64ab',
                                                                    }}>
                                                                    <EditIcon
                                                                        style={{
                                                                            verticalAlign:
                                                                                'bottom',
                                                                            fontSize:
                                                                                '14px',
                                                                        }}
                                                                    />
                                                                </span>
                                                            </span>
                                                        </div>
                                                    )}
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        className="price-content"
                                        container
                                        spacing={0}>
                                        <Grid
                                            className="price-container"
                                            item
                                            xs={9}>
                                            <Grid
                                                className="price-grid"
                                                container
                                                spacing={0}>
                                                <Grid
                                                    className="discount-price"
                                                    item
                                                    xs={5}>
                                                    {/*<span className="price-font"><i className="rmb"></i> <span className="price">{util.toMoney(this.getSkuDetails(productInfo.cartId).finalPrice)}</span> </span><br/>*/}
                                                    {this.isOfflineOemProduct(
                                                        productInfo,
                                                    ) ? (
                                                        <span testid="product-unit-price">
                                                            {T(
                                                                'oem_custom_order_product',
                                                            )}
                                                        </span>
                                                    ) : (
                                                        <>
                                                            <span
                                                                className="price-font"
                                                                testid="product-unit-price">
                                                                <i className="rmb"></i>{' '}
                                                                <span className="price">
                                                                    {util.toMoney(
                                                                        productInfo.unitPrice,
                                                                    )}
                                                                </span>{' '}
                                                            </span>
                                                            <br />
                                                            {T(
                                                                'order_your_preferential_price',
                                                            )}
                                                        </>
                                                    )}
                                                </Grid>

                                                <Grid
                                                    className="discount-code"
                                                    item
                                                    xs={7}>
                                                    {!this.isOfflineOemProduct(
                                                        productInfo,
                                                    ) &&
                                                    this.savingPrice(
                                                        productInfo,
                                                    ) > '0.00' ? (
                                                        <span testid="product-saving-price">
                                                            {T(
                                                                'order_save_colon',
                                                                [
                                                                    this.savingPrice(
                                                                        productInfo,
                                                                    ),
                                                                ],
                                                            )}
                                                        </span>
                                                    ) : null}
                                                </Grid>
                                                {/*
							      			<Grid className='discount-code' item xs={12}>
								      			<span>促销代码：{this.getSkuDetails(productInfo.cartId).activeCode}</span>
								      		</Grid>*/}
                                            </Grid>
                                        </Grid>

                                        <Grid
                                            className="product-number"
                                            testid="product-quantity"
                                            item
                                            xs={3}>
                                            <span>x{productInfo.quantity}</span>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </>
                        );
                    })}
                <EditCrdDialog
                    open={open}
                    onClose={this.onCloseCRD}
                    onSubmit={this.onSubmitCRD}
                    productInfo={currentProduct}
                    lines={productList}
                    holidays={holidays}
                />
            </Card>
        );
    }
}

export default ProductDetails;

/**
 * 数据结构示例
 * lines: [{ id, sku, currentCrd }]
 */
function EditCrdDialog({
    open,
    onClose,
    onSubmit,
    productInfo = {},
    lines = [],
    holidays = [],
}) {
    const [newCrd, setNewCrd] = useState(productInfo.crd || '');
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState(new Set());

    const normalizeDate = (value) => {
        if (!value) return '';
        return String(value).split('T')[0].replace(/\//g, '-');
    };

    const holidaySet = React.useMemo(() => {
        if (holidays && holidays.length > 0) {
            return new Set(
                holidays
                    .filter((x) => x.type === 'public_holiday')
                    .map((x) => x.date)
                    .map(normalizeDate)
                    .filter(Boolean),
            );
        }

        return new Set();
    }, [holidays]);
    const transferWorkdaySet = React.useMemo(() => {
        if (holidays && holidays.length > 0) {
            return new Set(
                holidays
                    .filter((x) => x.type === 'transfer_workday')
                    .map((x) => x.date)
                    .map(normalizeDate)
                    .filter(Boolean),
            );
        }

        return new Set();
    }, [holidays]);

    const isDateInRange = React.useCallback((range, dateStr) => {
        if (!dateStr) return false;
        if (range && range.status !== 'eligible') {
            return false;
        }
        if (!range || (!range.startDate && !range.endDate)) return true;
        const start = normalizeDate(range.startDate);
        const end = normalizeDate(range.endDate);
        if (!start || !end) return true;
        const date = parseISO(dateStr);
        return isWithinInterval(date, {
            start: parseISO(start),
            end: parseISO(end),
        });
    }, []);

    const getRangeText = (range) => {
        if (!range) return '';
        if (range.status !== 'eligible') {
            return T('order_date_range_not_available');
        }
        const start = normalizeDate(range.startDate);
        const end = normalizeDate(range.endDate);
        if (start && end) return `${T('order_date_range')} ${start} ~ ${end}`;
        return '';
    };

    React.useEffect(() => {
        if (open) {
            setNewCrd(productInfo.crd);
        }
    }, [open]);

    React.useEffect(() => {
        if (!newCrd) {
            setSelected(new Set());
            return;
        }
        setSelected((prev) => {
            const next = new Set();
            lines.forEach((row) => {
                const id = row.deliveryChannel + row.lineNumber;
                if (prev.has(id) && isDateInRange(row.CRD_Range, newCrd)) {
                    next.add(id);
                }
            });
            return next;
        });
    }, [newCrd, lines, isDateInRange]);

    const toggleOne = (id) => {
        setSelected((prev) => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    };

    const handleSubmit = () => {
        if (!newCrd) return;
        const selectedLinesMap = Array.from(selected).reduce((prev, cur) => {
            prev[cur] = newCrd;
            return prev;
        }, {});
        selectedLinesMap[productInfo.deliveryChannel + productInfo.lineNumber] =
            newCrd;
        const payload = {
            newCrd,
            selectedLinesMap,
        };
        onSubmit(payload);
        setSelected(new Set());
    };

    const shouldDisableDate = (date) => {
        if (!date) return false;
        const dateStr = format(date, 'yyyy-MM-dd');
        if (holidaySet.has(dateStr)) return true;
        if (productInfo && productInfo.CRD_Range) {
            return !isDateInRange(productInfo.CRD_Range, dateStr);
        }
        return false;
    };

    const handleDateChange = (date) => {
        if (!date) {
            setNewCrd('');
            return;
        }
        setNewCrd(format(date, 'yyyy-MM-dd'));
    };

    const renderDay = (day, selectedDate, dayInCurrentMonth, dayComponent) => {
        if (!dayInCurrentMonth) return dayComponent;
        const isTransferWorkday = transferWorkdaySet.has(
            format(day, 'yyyy-MM-dd'),
        );
        if (isTransferWorkday) {
            return (
                <div className="modify-crd-dialog__holiday-day">
                    {dayComponent}
                    <span
                        className="modify-crd-dialog__holiday-tag"
                        style={{color: '#1548d3'}}>
                        班
                    </span>
                </div>
            );
        }
        const isHoliday = holidaySet.has(format(day, 'yyyy-MM-dd'));
        if (!isHoliday) return dayComponent;
        return (
            <div className="modify-crd-dialog__holiday-day">
                {dayComponent}
                <span className="modify-crd-dialog__holiday-tag">休</span>
            </div>
        );
    };

    const lineList = lines.filter(
        (row) =>
            row.deliveryChannel + row.lineNumber !==
                productInfo.deliveryChannel + productInfo.lineNumber &&
            !row.freeGoodItem &&
            row.CRD_Range &&
            row.CRD_Range.status === 'eligible',
    );

    const selectableIds = lineList
        .filter((row) => isDateInRange(row.CRD_Range, newCrd))
        .map((row) => row.deliveryChannel + row.lineNumber);
    const allChecked =
        selectableIds.length > 0 && selected.size === selectableIds.length;
    const toggleAll = (checked) => {
        if (checked) {
            setSelected(new Set(selectableIds));
        } else {
            setSelected(new Set());
        }
    };

    return (
        <Dialog
            open={open}
            className="modify-crd-dialog"
            aria-labelledby="edit-crd-dialog-title">
            <DialogTitle
                disableTypography
                className="modify-crd-dialog__title"
                id="edit-crd-dialog-title">
                <div className="modify-crd-dialog__title-wrap">
                    <Typography className="modify-crd-dialog__title-text">
                        {T('expectDeliveryDateTitle')}
                    </Typography>
                    {/* <IconButton size="small" onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton> */}
                </div>
            </DialogTitle>

            <Divider />

            <DialogContent className="modify-crd-dialog__content">
                {/* 基本信息 */}
                <div className="modify-crd-dialog__info-block">
                    <div className="modify-crd-dialog__info-row">
                        <div className="modify-crd-dialog__info-item">
                            <span className="modify-crd-dialog__info-label">
                                {T('product_sku')}
                            </span>
                            {productInfo.sku}
                        </div>
                    </div>
                    <div className="modify-crd-dialog__info-row">
                        <div className="modify-crd-dialog__info-item">
                            <span className="modify-crd-dialog__info-label">
                                {T('product_name')}
                            </span>
                            {productInfo.productName}
                        </div>
                    </div>
                    <div className="modify-crd-dialog__info-row">
                        <div className="modify-crd-dialog__info-item">
                            <span className="modify-crd-dialog__info-label">
                                {T('product_crd_date_current')}
                            </span>
                            {productInfo.crd ? productInfo.crd : ''}
                        </div>
                    </div>
                </div>

                {/* 新CRD日期 */}
                <Typography className="modify-crd-dialog__field-label">
                    {T('product_crd_date_new')}
                    <span className="modify-crd-dialog__required">*</span>
                </Typography>
                <ThemeProvider theme={datePickerTheme}>
                    <MuiPickersUtilsProvider
                        utils={DateFnsUtils}
                        locale={zhCNLocale}>
                        <DatePicker
                            className="modify-crd-dialog__date-field"
                            variant="inline"
                            inputVariant="outlined"
                            size="small"
                            disableToolbar
                            toolbarTitle=""
                            autoOk
                            format="yyyy-MM-dd"
                            value={newCrd ? new Date(newCrd) : null}
                            onChange={handleDateChange}
                            shouldDisableDate={shouldDisableDate}
                            renderDay={renderDay}
                            error={!newCrd}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <EventIcon fontSize="small" />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </ThemeProvider>

                {lineList.length > 0 && (
                    <>
                        <Typography
                            className="modify-crd-dialog__field-label"
                            style={{marginTop: 12}}>
                            {T('crd_select_to_modify')}
                        </Typography>

                        <div className="modify-crd-dialog__table-wrap">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            padding="checkbox"
                                            className="modify-crd-dialog__table-head">
                                            <Checkbox
                                                checked={allChecked}
                                                onChange={(e) =>
                                                    toggleAll(e.target.checked)
                                                }
                                                disabled={
                                                    selectableIds.length === 0
                                                }
                                                inputProps={{
                                                    'aria-label': 'select-all',
                                                }}
                                                sx={{
                                                    '&.Mui-disabled': {
                                                        color: 'rgba(0, 0, 0, 0.1)',
                                                    },
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell className="modify-crd-dialog__table-head">
                                            {T('sku')}
                                        </TableCell>
                                        <TableCell className="modify-crd-dialog__table-head">
                                            {T('product_crd_date_current')}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {lineList.map((row) => {
                                        const checked = selected.has(
                                            row.deliveryChannel +
                                                row.lineNumber,
                                        );
                                        const inRange = isDateInRange(
                                            row.CRD_Range,
                                            newCrd,
                                        );
                                        const rangeText = getRangeText(
                                            row.CRD_Range,
                                        );
                                        const checkbox = (
                                            <Checkbox
                                                checked={checked}
                                                onChange={() =>
                                                    toggleOne(
                                                        row.deliveryChannel +
                                                            row.lineNumber,
                                                    )
                                                }
                                                disabled={!inRange}
                                                inputProps={{
                                                    'aria-label': `select-${
                                                        row.deliveryChannel +
                                                        row.lineNumber
                                                    }`,
                                                }}
                                                sx={{
                                                    '&.Mui-disabled': {
                                                        color: 'rgba(0, 0, 0, 0.1)',
                                                    },
                                                }}
                                            />
                                        );
                                        return (
                                            <TableRow
                                                key={
                                                    row.deliveryChannel +
                                                    row.lineNumber
                                                }
                                                hover>
                                                <TableCell
                                                    padding="checkbox"
                                                    className="modify-crd-dialog__table-cell">
                                                    {!inRange && rangeText ? (
                                                        <Tooltip
                                                            placement="right"
                                                            enterTouchDelay={0}
                                                            title={rangeText}>
                                                            <span>
                                                                {checkbox}
                                                            </span>
                                                        </Tooltip>
                                                    ) : (
                                                        checkbox
                                                    )}
                                                </TableCell>
                                                <TableCell className="modify-crd-dialog__table-cell">
                                                    <div
                                                        style={{
                                                            color: !inRange
                                                                ? '#aaa'
                                                                : undefined,
                                                        }}>
                                                        {row.sku}
                                                    </div>
                                                </TableCell>
                                                <TableCell
                                                    className="modify-crd-dialog__table-cell"
                                                    style={{minWidth: 100}}>
                                                    <div
                                                        style={{
                                                            color: !inRange
                                                                ? '#aaa'
                                                                : undefined,
                                                        }}>
                                                        {row.crd}
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </div>
                    </>
                )}
                {/* 表格 */}
            </DialogContent>

            <DialogActions className="modify-crd-dialog__actions">
                <Button
                    variant="outlined"
                    onClick={() => {
                        onClose();
                        setSelected(new Set());
                    }}
                    className="modify-crd-dialog__btn-cancel"
                    disabled={loading}>
                    {T('cancel')}
                </Button>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    className="modify-crd-dialog__btn-submit"
                    disabled={loading || !newCrd}>
                    {T('order_confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
